export default "__VITE_ASSET__CUaz3MHj__"